import { MutationTree } from 'vuex';
import { IMenuSearchState } from './types';

const mutations: MutationTree<IMenuSearchState> = {
  reset(state) {
    state.results = [];
    state.lookup = '';
  },

  lookup(state, lookup) {
    state.lookup = lookup;
  },

  results(state, results) {
    state.results = results;
  },

  setSelectedResultIndex(state, newIndex) {
    state.selectedResultIndex = newIndex;
  },

  setCacheSuffix(state, cacheSuffix) {
    state.cacheSuffix = cacheSuffix;
  },

  setIsSearching(state, isSearching) {
    state.isSearching = isSearching;
  }
};

export default mutations;
